import AdaptiveDatePicker from "app/components/AdaptiveDatePicker";
import CustomTooltip from "app/components/Tooltip";
import { format } from "date-fns";
import React from "react";
import { dateFormatter } from "utils/helpers";

interface CustomProps {
  value: string;
  onUpdate: (id: string) => void;
}

const DueDateSelection: React.FC<CustomProps> = ({ value, onUpdate }) => {
  const parsedDate = value ? new Date(value) : null;
  const handleChange = (val: Date | null) => {
    // Do something with new date
    if (val) {
      console.log("Selected date:", val.toISOString());
      onUpdate(val.toISOString());
    }
  };
  return (
    <div className=" relative">
      <AdaptiveDatePicker
        value={parsedDate}
        onChange={(v) => {
          handleChange(v);
        }}
        trigger={
          <button className="flex items-center justify-start hover:border hover:border-[#BDC0C3] p-[4px] rounded-[2px] min-w-[109px] cursor-pointer ">
            <CustomTooltip
              text="Change due date"
              className="flex items-center "
              position="bottom"
            >
              <div className="flex items-center gap-2 w-full">
                <span
                  className={`text-sm font-normal text-nowrap overflow-hidden text-ellipsis `}
                >
                  {parsedDate ? dateFormatter(parsedDate) : "-"}
                </span>
              </div>
            </CustomTooltip>
          </button>
        }
        isDisablePastDate
      />
      
    </div>
  );
};

export default DueDateSelection;
